module.exports = __webpack_public_path__ + "img/tour.7ef6b156.png";